var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31786 6.95525C8.91786 6.33025 9.28572 5.4856 9.28572 4.55703V4.37489C9.28572 2.45346 7.7125 0.894531 5.77321 0.894531H0.489286C0.219643 0.894531 0 1.11417 0 1.38382V13.5106C0 13.8017 0.235714 14.0374 0.526786 14.0374H6.21786C8.30714 14.0374 10 12.3552 10 10.2785V10.082C10 8.77846 9.33214 7.63025 8.31786 6.95525ZM1.71429 2.60882H5.72679C6.74643 2.60882 7.57143 3.40167 7.57143 4.38203V4.55167C7.57143 5.53025 6.74464 6.32489 5.72679 6.32489H1.71429V2.60882ZM8.26071 10.2767C8.26071 11.3999 7.3375 12.3106 6.19821 12.3106H1.71429V8.04989H6.19821C7.3375 8.04989 8.26071 8.9606 8.26071 10.0838V10.2767Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.f4333dac98365b003cce02dff332e5ca.svg";
export { ForwardRef as ReactComponent };